import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO32 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK003-2.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO32
